
<div class="border-0 px-4 py-1 overflow-auto">
  <NavigationBackButton/>
  <div class="card-header card-header-primary text-white shadow rounded-lg mt-3">
        <div class="nav-tabs-navigation">
            <div class="nav-tabs-wrapper">
            <ul class="nav nav-tabs" data-tabs="tabs">
                <li class="rounded-lg me-2 nav-item">
                <a class="text-dark-blue text-decoration-none fs-5 fw-bold nav-link" href="#profile" data-toggle="tab">
                   <span><i class="bi bi-box fs-4 me-2"></i></span> Manage Your Packages
                </a>
                </li>
            </ul>
            <div class="me-3 d-block text-end">
                <button class="btn btn-primary-dark btn-sm  text-xxs shadow mb-1"
                 data-bs-toggle="modal"
                 data-bs-target="#create_package_service"
                 @click="open_create_modal">
                Create New Package
                </button>

            </div>
            </div>
        </div>
    </div>
    <div class="glassy-table mt-2 rounded-lg border-0 shadow">
        <div class="card-body rounded-lg shadow">
            
            <div class="p-4 border-0 rounded-lg">
                <div class="table-responsive">
                    <table id="forms_table" class="table table-hover text-xs">
                        <thead class="custom-header">
                            <tr>
                                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Name</th>
                                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Description</th>
                                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Date Created</th>
                                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Price</th>
                                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Changed from 'forms' to 'table_safe_form_list' -->
                            <tr v-for="(service) in table_safe_form_list" :key="service.id">
                                <td class="text-xxs text-start">{{ service.name }}</td>
                                <td class="text-xxs text-start">{{ service.description }}</td>
                                <td class="text-xxs text-start">{{ service.date_created }}</td>
                                <td class="text-xxs text-start">
                                    <span class="status-badge">{{ service.price }}</span>
                                </td>

                                <td>
                                    <button class="btn btn-primary-dark btn-sm rounded shadow me-2 text-xxs"
                                        data-bs-toggle="modal"
                                        data-bs-target="#edit_package_service"
                                        @click="open_edit_modal(service)">Edit
                                    </button>
                                    <button class="btn btn-primary-dark btn-sm rounded shadow me-2 text-xxs"
                                        data-bs-toggle="modal"
                                        data-bs-target="#assign_services"
                                        @click="assign_services_modal(service)">Assign Services
                                    </button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<teleport to="body">
  <div class="modal fade" id="edit_package_service" tabindex="-1" aria-labelledby="edit_package_service_label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h5 class="modal-title text-white text-xxs">Edit Package</h5>
          <button type="button" class="modal-btn-close btn-close"data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
          <div class="mb-3">
              <label class="modal-form-label form-label text-xxs">Package Name:</label>
              <input type="text" class="modal-form-control form-control text-xxs" v-model="current_package.package_name" placeholder="Enter package name">
          </div>
          <div class="mb-3">
              <label class="modal-form-label form-label text-xxs">Package Description:</label>
              <textarea class="modal-form-control form-control text-xxs" v-model="current_package.package_description" ></textarea>
          </div>
          <div class="mb-3">
              <label class="modal-form-label form-label text-xxs">Package Price:</label>
              <input type="text" class="modal-form-control form-control text-xxs" v-model="current_package.price" placeholder="Enter price">
          </div>
          </div>
          <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="update_service">
            Save
          </button>

          </div>
      </div>
      </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="create_package_service" tabindex="-1" aria-labelledby="create_package_service_label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
              <h5 class="modal-title text-white text-xxs">Create Package Services </h5>
              <button type="button" class="modal-btn-close btn-close"  data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
              <div class="mb-3">
                  <label class="modal-form-label form-label text-xxs">Package Name:</label>
                  <input type="text" class="modal-form-control form-control text-xxs" v-model="current_package.package_name" placeholder="Enter package name">
              </div>
              <div class="mb-3">
                  <label class="modal-form-label form-label text-xxs">Package Description:</label>
                  <textarea class="modal-form-control form-control text-xxs" v-model="current_package.package_description"></textarea>
              </div>
              <div class="mb-3">
                  <label class="modal-form-label form-label text-xxs">Package Price:</label>
                  <input type="text" class="modal-form-control form-control text-xxs" v-model="current_package.price" placeholder="Enter price"> 
              </div>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="create_package_service">Save</button>
          </div>
          </div>
      </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="assign_services" tabindex="-1" aria-labelledby="assign_services_label" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h5 class="modal-title text-white text-xxs">Assign Services</h5>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <!-- Entity/Trust Type Table -->
          <div class="mb-4">
            <h6 class="mb-3 text-xxs">Select Services</h6>
            <div class="table-responsive">
              <table id="services_table" class="table table-hover table-sm align-middle">
                <thead class="custom-header">
                  <tr>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Name</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Description</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Price</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Assign</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(service, index) in table_safe_services_list" :key="service.id">
                    <td>
                      <label class="modal-form-check-label form-check-label text-xxs" :for="'type-' + index">
                        {{ service.name }}
                      </label>
                    </td>
                    <td class="text-muted text-xxs">{{ service.description }}</td>
                    <td class="text-muted text-xxs">{{ service.price }}</td>
                    <td class="ps-3">
                      <div class="modal-form-check form-check form-switch mb-0 text-xxs">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :id="'type-' + index"
                          v-model="service.selected"
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>


        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            @click="save_assignment"
          >
            Save Assignment
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>